import React, { useEffect } from "react";
import "./About.css";
import { Link } from "react-router-dom";
import v1 from '../Images/vision.png';
import m1 from '../Images/mission.png';
import career from '../Images/career.png';

const AboutUs = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const counters = document.querySelectorAll(".count");
            counters.forEach(counter => {
              const target = +counter.getAttribute("data-target");
              const suffix = counter.getAttribute("data-suffix") || "";
              let count = 0;
              const increment = Math.max(1, Math.ceil(target / 200));

              const update = () => {
                if (count < target) {
                  count += increment;
                  if (count > target) count = target;
                  counter.innerText = `${count}${suffix}`;
                  setTimeout(update, 15);
                } else {
                  counter.innerText = `${target}${suffix}`;
                }
              };
              update();
            });
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );

    const section = document.querySelector(".impact-stats");
    if (section) observer.observe(section);
  }, []);

  const roles = [
    {
      label: "Students and Job Seekers",
      icon: "https://cdn-icons-png.flaticon.com/512/3135/3135755.png"
    },
    {
      label: "Colleges and Institutions",
      icon: "https://cdn-icons-png.flaticon.com/512/2936/2936801.png"
    },
    {
      label: "Career Coaches and Mentors",
      icon: "https://cdn-icons-png.flaticon.com/512/609/609803.png"
    },
    {
      label: "Recruiters and HR Leaders",
      icon: "https://cdn-icons-png.flaticon.com/512/3034/3034845.png"
    }
  ];

  const differentiators = [
    {
      title: "Human and AI Hybrid Model",
      desc: "Personalized coaching that balances technology and real mentorship.",
      icon: "https://cdn-icons-png.flaticon.com/512/4140/4140037.png"
    },
    {
      title: "End-to-End Career Solution",
      desc: "Everything from resume to job offer in one connected platform.",
      icon:career
    },
    {
      title: "Experience-Led Learning",
      desc: "Simulations, role-based tasks, and skill validation to boost real employability.",
      icon: "https://cdn-icons-png.flaticon.com/512/1048/1048953.png"
    },
    {
      title: "Placement Analytics and Visibility",
      desc: "Insightful data for institutions and recruiters to measure progress and outcomes.",
      icon: "https://cdn-icons-png.flaticon.com/512/1828/1828911.png"
    }
  ];

  return (
    <section className="about-wrapper1">
      {/* Hero Section */}
      <div className="hero-section2 fade-in">
        <h1>About <span>SkillsHap</span></h1>
        <p>Empowering Careers. Building Futures.</p>
        <p>
          SkillsHap is a career-centric AI-driven placement platform built to bridge the gap between skills, mentorship, and real job outcomes.
          We’re on a mission to spotlight skilled individuals, especially from Tier 2 & Tier 3 towns, and help them become job-ready through a unified ecosystem of tools, training, and career guidance.
          We bring together learners, colleges, training institutes, EdTech platforms, career coaches, and employers—creating one powerful ecosystem to launch careers at scale.
        </p>
      </div>

      {/* Vision & Mission Row */}
      <div className="vision-mission-section fade-in delay-2">
        <div className="vision-card glass-card">
          <img src={v1} alt="Vision Icon" className="section-icon" />
          <h2>Our Vision</h2>
          <p>To become India’s most impactful career transformation platform where talent is nurtured, not filtered.</p>
        </div>
        <div className="mission-card glass-card">
          <img src={m1} alt="Mission Icon" className="section-icon" />
          <h2>Our Mission</h2>
          <p>To build a unified ecosystem where every learner is empowered with the tools, training, mentorship, and visibility they need to succeed in the modern workforce.</p>
        </div>
      </div>

      {/* What We Offer */}
      <div className="what-we-offer glass-card fade-up delay-3">
        <img src="https://cdn-icons-png.flaticon.com/512/8072/8072897.png" alt="Offer" className="section-icon" />
        <h3>What We Offer</h3>
        <ul>
          <li>AI-powered Resume Builder with ATS optimization</li>
          <li>Blended Mentorship Model (AI + Human) for personalized career coaching</li>
          <li>Simulation-Based Skill Assessments and role-specific projects</li>
          <li>Mock Interviews + Feedback from working professionals</li>
          <li>All-in-One Job Portal + Tracker to apply, track, and manage job opportunities</li>
        </ul>
      </div>

      {/* Who We Serve */}
      <div className="section fade-in delay-2">
        <h2>Who We Serve</h2>
        <div className="card-grid">
          {roles.map((role, i) => (
            <div className="role-card glass-card" key={i}>
              <img src={role.icon} alt={role.label} className="card-icon" />
              <p>{role.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Differentiators */}
      <div className="section fade-in delay-3">
        <h2>What Makes Us Different</h2>
        <div className="card-grid">
          {differentiators.map((item, i) => (
            <div className="diff-card glass-card" key={i}>
              <img src={item.icon} alt={item.title} className="card-icon" />
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Impact Section with Counter */}
      <div className="impact-section enhanced-bg">
        <h2 className="impact-title">Our Impact</h2>
        <div className="impact-stats animate-count">
          <div className="impact-card glass-card fade-up delay-1">
            <h3 className="count" data-target="3000">0</h3>
            <p>Candidates Placed</p>
          </div>
          <div className="impact-card glass-card fade-up delay-1">
            <h3 className="count" data-target="10000">0</h3>
            <p>Learners Trained</p>
          </div>
          <div className="impact-card glass-card fade-up delay-1">
            <h3 className="count" data-target="50">0</h3>
            <p>Partners Onboarded</p>
          </div>
          <div className="impact-card glass-card fade-up delay-1">
            <h3 className="count" data-target="60" data-suffix="%">0%</h3>
            <p>Improved Job Readiness</p>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="vision-team-section fade-in delay-2">
        <div className="vision-card glass-card">
          <h2>Our Team</h2>
          <p>We are a diverse team of career coaches, technologists, educators, and growth strategists. What unites us is our belief that career development should be accessible, personalized, and outcome-driven.</p>
        </div>
      </div>

      {/* CTA */}
      <div className="cta-section fade-up delay-6">
        <img src="https://cdn-icons-png.flaticon.com/512/3135/3135799.png" alt="CTA Banner" className="cta-image" />
        <h2>Join the Movement</h2>
        <p>Whether you are a learner, trainer, recruiter, or college, SkillsHap offers tools and community to accelerate career outcomes.</p>
        <Link to="/SignupForm"><button>Get Started with SkillsHap</button></Link>
      </div>
    </section>
  );
};

export default AboutUs;